import React, { useState, useEffect } from 'react';

import cloneDeep from 'lodash/cloneDeep';
import { Link } from 'react-router-dom';
import ReactModal from 'react-modal';
import { Helmet } from 'react-helmet';
import { useToasts } from 'react-toast-notifications';
import H1 from 'components/H1';
import H2 from 'components/H2';
import { Flex, Box, Button } from 'rebass';
import { Input, Select, Label } from '@rebass/forms';
import helpers from 'utils/helpers';
import services from 'services/services';
import service_accounts from 'services/accounts';
import { FiEdit, FiPlayCircle } from 'react-icons/fi';
import config from 'config';

import VariablesHelper from 'components/EmailTools/VariablesHelper';
import EmailEditor from 'components/EmailTools/EmailEditor';
import AppPageBreadcrumbs from 'components/AppPageWrapper/AppPageBreadcrumbs';
import AppPageWrapper from 'components/AppPageWrapper';
import AppPageWrapperSectionHeader from 'components/AppPageWrapper/AppPageWrapperSectionHeader';
import AppPageWrapperSectionBody from 'components/AppPageWrapper/AppPageWrapperSectionBody';
import AppPageWrapperSectionSubHeader from 'components/AppPageWrapper/AppPageWrapperSectionSubHeader';
import SettingsPageSubNav from 'containers/SettingsPage/SettingsPageSubNav';
import AppPageSubnav from 'components/AppPageWrapper/AppPageSubnav';
import ListWrapper from 'components/ListWrapper';
import ItemWrapper from 'components/ItemWrapper';
import InputSearch from 'components/InputSearch';
let saveDelay = null;

function SettingsEmailTemplateIndividualPage(props) {
    const [emailTemplate, setEmailTemplate] = useState({});
    const { addToast } = useToasts();

    useEffect(() => {
        getEmailTemplateXHR();
    }, []);

    function getEmailTemplateXHR() {
        //console.log(props.match)
        service_accounts.getEmailTemplate(props.match.params.id).then(email_template => {

            email_template.body = helpers.isObject(email_template.body)
                ? email_template.body
                : helpers.makeBlocksFromText(email_template.body);

            setEmailTemplate(email_template);
        });
    }

    function onChangeEmailTemplate(key, val) {
        let et = cloneDeep(emailTemplate);
        et[key] = val;

        setEmailTemplate(et);

        // detect change, and clear timeout if exists
        if (saveDelay) {
            clearTimeout(saveDelay);
        }

        saveDelay = setTimeout(() => {
            updateEmailTemplateXHR(et);
        }, 500);
    }
    
    function updateEmailTemplateXHR(emailTemplate_arg) {
        console.log(emailTemplate_arg);

        //setEmailTemplate(prev => ({...prev, [key]: val }));

        //return;
        service_accounts
            .updateEmailTemplate(emailTemplate_arg)
            .then(email_template => {

                /*addToast('Successfully saved', {
                    appearance: 'success',
                    autoDismiss: true
                });*/
            })
            .catch(error => {
                const errorText = services.parseXhrErrors(error);

                addToast(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    return (
        <Flex style={{ width: '100%' }}>
            <AppPageWrapper>
                <Helmet>
                    <title>Email Template</title>
                </Helmet>
                <AppPageSubnav>
                    <SettingsPageSubNav/>
                </AppPageSubnav>
                <AppPageWrapperSectionHeader>
                    <Box>
                        <AppPageBreadcrumbs items={[
                            { url: `/settings/email-templates`, title: `Email Templates`},
                            { url: `/settings/email-templates/${props.match.params.id}`, title: emailTemplate.title}
                        ]}>
                        </AppPageBreadcrumbs>
                    </Box>
                </AppPageWrapperSectionHeader>
                <AppPageWrapperSectionBody>
                    {emailTemplate.id > 0 && 
                        <Flex mx={4} mb={4} className='form-wrapper' style={{ width: '100%', flexDirection: 'column' }}>
                            <Flex sx={{gridGap: 4, width: '100%'}}>
                                <Box width={1/2}>
                                    <Label htmlFor="title">Email Template Title</Label>
                                    <Input
                                        type="text"
                                        name="title"
                                        value={emailTemplate.title}
                                        onChange={e => onChangeEmailTemplate('title', e.target.value)}
                                        placeholder="Title"

                                    />
                                </Box>
                                <Box width={1/2}>
                                    <VariablesHelper />
                                </Box>
                            </Flex>

                            <Label htmlFor="email_confirmation_body" mt={3}>
                                Email Body
                            </Label>
                            {emailTemplate.body && (
                                <Box sx={{width: '100%'}}>
                                    <EmailEditor
                                        editorData={emailTemplate.body}
                                        onChange={(editor, editorData) => { onChangeEmailTemplate('body', editorData) }}
                                    />
                                </Box>
                            )}
                        </Flex>
                    }

                </AppPageWrapperSectionBody>
            </AppPageWrapper>
        </Flex>
    );
}

export default SettingsEmailTemplateIndividualPage;
